module.exports = __webpack_public_path__ + "img/seo-profi-berlin.324152c4.jpg";